import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { api } from '../utils/api.js';
import { API_ENDPOINTS } from '../config/api.js';
import AuthForm from '../components/AuthForm.jsx';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    
    if (formData.newPassword !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }
    
    try {
      await api.post(API_ENDPOINTS.RESET_PASSWORD, {
        email: formData.email,
        token: formData.token,
        newPassword: formData.newPassword
      });
      
      // Success - redirect to login
      navigate('/login', { 
        state: { message: 'Password reset successful! Please sign in.' }
      });
    } catch (err) {
      setError(err.data?.error || err.message || 'Failed to reset password');
    }
    
    setLoading(false);
  };

  const fields = [
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      required: true
    },
    {
      name: 'token',
      label: 'Reset Token',
      type: 'text',
      placeholder: 'Token from email',
      required: true
    },
    {
      name: 'newPassword',
      label: 'New Password',
      type: 'password',
      placeholder: '••••••••',
      required: true
    },
    {
      name: 'confirmPassword',
      label: 'Confirm Password',
      type: 'password',
      placeholder: '••••••••',
      required: true
    }
  ];

  const footer = (
    <div>
      Remember your password?{' '}
      <Link to="/login" style={{ color: '#60a5fa', textDecoration: 'none' }}>
        Sign in
      </Link>
    </div>
  );

  return (
    <AuthForm
      title="Reset Password"
      fields={fields}
      onSubmit={handleSubmit}
      submitText="Reset Password"
      error={error}
      loading={loading}
      footer={footer}
    />
  );
};

export default ResetPasswordPage;

